'use client'

import { ReactNode, useState } from 'react'

import { useOnFirstScroll } from '@/hooks'

/**
 * HOC for rendering a component only when the user first scrolls the page.
 */
export const RenderOnScroll = ({
	element,
	containerCls,
}: {
	element: ReactNode
	containerCls?: string
}) => {
	const [shouldDisplay, setShouldDisplay] = useState(false)

	useOnFirstScroll(() => {
		setShouldDisplay(true)
	})

	return (
		<div
			ref={(container) => {
				if (container) {
					const { top, bottom } = container.getBoundingClientRect()
					const isInView = top < window.innerHeight && bottom > 0
					if (isInView) {
						setShouldDisplay(true)
					}
				}
			}}
			className={containerCls}
		>
			{shouldDisplay ? element : null}
		</div>
	)
}
